import axios from 'axios';

const BASE = '/project-management/my-work';

/**
 * Fetch My Work weekly overview metrics (Tasks status counts, time breakdown, capacity)
 */
export const getMyWorkOverview = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/overview`, { params });
        return response.data;
    } catch (error) {
        console.warn('My Work Overview API fallback to local calculation:', error?.message);
        return null;
    }
};

/**
 * Fetch AI Work Summary for the selected period
 */
export const getMyWorkAiSummary = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/ai-summary`, { params });
        return response.data;
    } catch (error) {
        console.warn('My Work AI Summary API fallback:', error?.message);
        return null;
    }
};

/**
 * Force refresh the AI Work Summary
 */
export const refreshMyWorkAiSummary = async (payload = {}) => {
    try {
        const response = await axios.post(`${BASE}/ai-summary/refresh`, payload);
        return response.data;
    } catch (error) {
        console.warn('My Work AI Summary Refresh fallback:', error?.message);
        return null;
    }
};

/**
 * Fetch user-scoped tasks
 */
export const getMyWorkTasks = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/tasks`, { params });
        return response.data;
    } catch (error) {
        console.warn('My Work Tasks API fallback:', error?.message);
        return null;
    }
};

/**
 * Fetch employee capacity breakdown
 */
export const getMyWorkCapacity = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/capacity`, { params });
        return response.data;
    } catch (error) {
        console.warn('My Work Capacity API fallback:', error?.message);
        return null;
    }
};

